import {get, post} from '../index'
export default {
  // 获取支付码列表
  getSweepPaymentCodeList (querys) {
    return get('/payqr/payList', querys)
  },
  // 获取支付记录
  getSweepPaymentReocrdList (querys) {
    return get('/payqr/payRecord', querys)
  },
  // 获取支付轮播列表
  getSweepPaymentBannerList (querys) {
    return get('/payqr/payqrCarousel', querys)
  },
  // 添加修改轮播图
  addEditSweepPaymentBanner (querys) {
    return post('/payqr/createCarousel', querys)
  },
  // 轮播图回显
  getSweepPaymentBannerInfo (querys) {
    return get('/payqr/carouselInfo', querys)
  },
  // 上下架、删除轮播图
  updateSweepPaymentBanner (querys) {
    return post('/payqr/changeCarousel', querys)
  },
  // 支付设置表单信息回显
  getSweepPaymentSettingInfo () {
    return get('/payqr/payConfig')
  },
  // 支付设置编辑
  sweepPaymentSwtting (querys) {
    return post('/payqr/create_config', querys)
  },
  // 生成支付码
  createQRCode (querys) {
    return post('/payqr/createPay', querys)
  },
  // 下载支付码
  downloadQRCode (querys) {
    return get('/payqr/downloadPay', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/sweepPayment.js